"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.logger = void 0;
var logger = function () {
    var argv = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        argv[_i] = arguments[_i];
    }
    var date = new Date();
    var dateStrang = '[Seguro-worker-lib INFO '
        + "".concat(date.getHours(), ":").concat(date.getMinutes(), ":")
        + "".concat(date.getSeconds(), ":").concat(date.getMilliseconds(), "] ");
    /* eslint-disable no-console */
    return console.log.apply(console, __spreadArray([dateStrang], argv, false));
    /* eslint-enable no-console */
};
exports.logger = logger;
